import React, { useCallback, useState } from 'react';
import { Spinner } from '@unite-us/app-components';
import { get } from 'lodash';
import { useIsClientsDrawer } from '../context/InteractionsContext';
import usePagination from '../hooks/usePagination';
import { useInteractions } from '../hooks/useInteractions';
import { StructuredInteractionsForm } from './form/StructuredInteractionsForm';
import { Pagination } from './Pagination';
import { StructuredInteractionsHeader } from './StructuredInteractionsHeader';
import { StructuredInteractionsList } from './StructuredInteractionsList';

export function InteractionsContent() {
  const isClientsDrawer = useIsClientsDrawer();
  const paginationProps = usePagination();
  const { interactions, data, isLoading } = useInteractions({
    pageNumber: paginationProps.pageNumber,
    pageSize: paginationProps.pageSize,
  });
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [clickedIdx, setClickedIdx] = useState();

  const totalItemCount = get(data, 'data.meta.page.total_count', 0);
  const totalPageCount = get(data, 'data.meta.page.total_pages', 0);

  const openForm = useCallback(() => {
    setOpen(false);
    setClickedIdx(undefined);
    setIsFormOpen(true);
  }, []);

  const closeForm = useCallback(() => {
    setIsFormOpen(false);
  }, []);

  const openEdit = useCallback((idx) => {
    setIsFormOpen(false);
    setClickedIdx(idx);
    setOpen(true);
  }, []);

  const closeEdit = useCallback(() => {
    setOpen(false);
    setClickedIdx(undefined);
  }, []);

  return (
    <div
      className={`structured-interactions panel-wrapper ${isClientsDrawer ? 'mb-4' : 'mb-6'}`}
      data-testid="structured-interactions"
      data-test-element="structured-interactions"
    >
      <StructuredInteractionsHeader
        disabled={isFormOpen || open}
        labelText="Add Interaction"
        onClick={openForm}
        title="Interactions"
      />
      {isFormOpen && (
        <StructuredInteractionsForm
          isEditing={false}
          onClose={closeForm}
        />
      )}
      {isLoading ? (
        <Spinner scale={0.45} />
      ) : (
        <StructuredInteractionsList
          interactions={interactions}
          clickedIdx={open ? clickedIdx : undefined}
          onEdit={openEdit}
          onCloseEdit={closeEdit}
        />
      )}
      {!isClientsDrawer && (
        <Pagination
          {...paginationProps}
          totalItemCount={totalItemCount}
          totalPageCount={totalPageCount}
        />
      )}
    </div>
  );
}
